const controller = "deal-questions";

export default {
  controller,
  context: (id: number) => `deals/${id}/question-context`,
  create: (id: number) => `deals/${id}/questions`,
  status: (id: number) => `${controller}/${id}/status`,
  cardPayments: (id: number) => `deals/${id}/card-payments`,
  specialFinance: (id: number) => `deals/${id}/special-finance-snapshot`,
};
